import { queryOptions, useQuery } from "@tanstack/react-query";

import {getStoreList} from "@/components/app/store/services";

import { GET_STORE_LIST } from "@/constant/query-key";


export function storeListQueryOptions(store:string,offset:number){
  return queryOptions({
    queryKey: [GET_STORE_LIST, store, offset],  
    queryFn: () => getStoreList(store,offset),
  })
}


export const getStoreListQuery = (store:string, offset:number) => queryOptions(storeListQueryOptions(store,offset))

  export function useGetStoreList(store:string,offset:number) {
    return useQuery(storeListQueryOptions(store,offset));
  }